import styles from "src/components/atoms/Input/styles.module.css";
import cx from "classnames";
import { Msg, MsgProps } from "src/i18n/Msg";
import EyeIcon from "src/assets/icons/eye.svg";
import EyeHideIcon from "src/assets/icons/eyeHide.svg";

import React, { useState } from "react";
import { DictionaryKey } from "src/types/language";

type Props = {
  label?: MsgProps;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  error?: string;
  defaultValue?: string;
  leftIconSrc?: string;
  password?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  rightIconSrc?: string;
  handleBlur?: () => void;
  className?: string;
  errorWithoutTranslation?: boolean;
  wrapperClassName?: string;
  iconClick?: () => void;
  showerrorBorder?: boolean;
};

export const Input: React.FC<Props> = ({
  label,
  value,
  onChange,
  disabled,
  placeholder,
  required,
  error,
  defaultValue,
  leftIconSrc,
  password,
  onClick,
  rightIconSrc,
  handleBlur,
  className,
  errorWithoutTranslation,
  wrapperClassName,
  iconClick,
  showerrorBorder,
}) => {
  const [showPassword, setShowPassword] = useState(password ? false : true);
  const handleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <div className={cx(styles.inputWrapper, wrapperClassName)}>
      {label && (
        <label className={styles.label}>
          {label && <Msg {...label} />}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div className={styles.inputContainer}>
        {leftIconSrc && (
          <img
            role="button"
            className={styles.leftIcon}
            src={leftIconSrc}
            alt="icon"
          />
        )}
        {rightIconSrc && (
          <img
            className={styles.rightIcon}
            src={rightIconSrc}
            alt="right-icon"
            onClick={iconClick}
            role="button"
          />
        )}
        {password && (
          <img
            className={styles.paswordIcon}
            onClick={handleShowPassword}
            role="button"
            src={!showPassword ? EyeIcon : EyeHideIcon}
            alt="eye-icon"
          />
        )}
        <input
          type={!showPassword ? "password" : "text"}
          className={cx(styles.input, className, {
            [styles.disabledInput]: disabled,
            [styles.errorInput]: error || showerrorBorder,
          })}
          onClick={onClick}
          onBlur={handleBlur}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          placeholder={placeholder ?? ""}
          disabled={disabled}
        />
        {error && (
          <p className="errorText">
            {errorWithoutTranslation ? (
              error
            ) : (
              <Msg id={error as DictionaryKey} />
            )}
          </p>
        )}
      </div>
    </div>
  );
};
